import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class SchoolService {
  public navigateToNotifications = new BehaviorSubject<any>(false);
  public profileUpdated = new BehaviorSubject<any>(false);
  public showleftMenue = new BehaviorSubject<any>(false);

  constructor(private httpService: HttpService) {}

  subscriptionPlan(payload: any) {
    return this.httpService.post('school/subscription-plan', payload);
  }
  purchasePlan(payload: any) {
    return this.httpService.post('school/purchase-plan', payload);
  }
  fetchCouponList(payload: any) {
    return this.httpService.post('school/coupon-list', payload);
  }  
  fetchTransactions(payload: any) {
    return this.httpService.post('school/transaction-list', payload);
  }
  deactivateCoupon(payload: any) {
    return this.httpService.post('school/coupon/deactive', payload);
  }  
  deactiveCoach(payload: any) {
    return this.httpService.post('school/coach/deactive', payload);
  }  
  renewCoupon(payload: any) {
    return this.httpService.post('school/coupon/renew', payload);
  }  
  schoolDetails(payload: any) {
    return this.httpService.post('school/school-details', payload);
  }
   updatePassword(payload: any) {
    return this.httpService.post('school/change-password', payload);
  }   
  updateSchool(payload: any) {
    return this.httpService.post('school/update', payload);
  }
}
